// extracted by mini-css-extract-plugin
export default {"grid":"SfVVTCFA7KkfCbxh5BCg","strip":"xzTNeNRkKY6PewWMgho1","dragOverlay":"x_TzdWYOSazb4uHtIgUL","dragOverlayImage":"N2DgByppnqwvkO8icq0y"};